type TruckIconProps = {
  width?: string;
  height?: string;
  fill?: string;
  onClick?: any;
};

const TruckIcon = ({ width, height, fill, onClick }: TruckIconProps) => {
  return (
    <svg
      onClick={onClick}
      width={width ? width : "10vw"}
      height={height ? height : "10vw"}
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1116_1028)">
        <path
          fill={fill ? fill : "black"}
          d="M24.4668 47.8778C24.1514 50.0908 23.0482 52.1158 21.3598 53.5807C19.6713 55.0456 17.511 55.8521 15.2756 55.8521C13.0403 55.8521 10.88 55.0456 9.19151 53.5807C7.50306 52.1158 6.39985 50.0908 6.08451 47.8778H3.33911V16.0471C3.33911 15.3436 3.61858 14.6689 4.11603 14.1714C4.61348 13.674 5.28817 13.3945 5.99167 13.3945H43.1275C43.831 13.3945 44.5057 13.674 45.0032 14.1714C45.5006 14.6689 45.7801 15.3436 45.7801 16.0471V21.3522H53.7378L61.6955 32.111V47.8778H56.2975C55.9822 50.0908 54.8789 52.1158 53.1905 53.5807C51.502 55.0456 49.3417 55.8521 47.1064 55.8521C44.871 55.8521 42.7107 55.0456 41.0222 53.5807C39.3338 52.1158 38.2306 50.0908 37.9152 47.8778H24.4668ZM40.475 18.6997H8.64423V40.0528C9.69083 38.9843 10.9801 38.1845 12.4023 37.7215C13.8244 37.2584 15.3374 37.1458 16.8125 37.3933C18.2875 37.6407 19.6809 38.2409 20.8742 39.1427C22.0674 40.0445 23.025 41.2212 23.6657 42.5727H38.7163C39.1619 41.6363 39.7588 40.7849 40.475 40.0528V18.6997ZM45.7801 34.615H56.3903V33.859L51.064 26.6573H45.7801V34.615ZM47.1064 50.5304C48.162 50.5304 49.1743 50.111 49.9208 49.3646C50.6672 48.6182 51.0865 47.6058 51.0865 46.5502C51.0865 45.4946 50.6672 44.4822 49.9208 43.7358C49.1743 42.9894 48.162 42.57 47.1064 42.57C46.0508 42.57 45.0384 42.9894 44.292 43.7358C43.5455 44.4822 43.1262 45.4946 43.1262 46.5502C43.1262 47.6058 43.5455 48.6182 44.292 49.3646C45.0384 50.111 46.0508 50.5304 47.1064 50.5304V50.5304ZM19.2545 46.5515C19.2545 46.029 19.1516 45.5116 18.9516 45.0289C18.7517 44.5462 18.4586 44.1075 18.0891 43.7381C17.7196 43.3686 17.281 43.0755 16.7983 42.8756C16.3155 42.6756 15.7981 42.5727 15.2756 42.5727C14.7531 42.5727 14.2357 42.6756 13.753 42.8756C13.2703 43.0755 12.8316 43.3686 12.4622 43.7381C12.0927 44.1075 11.7996 44.5462 11.5997 45.0289C11.3997 45.5116 11.2968 46.029 11.2968 46.5515C11.2968 47.6068 11.716 48.6188 12.4622 49.365C13.2083 50.1112 14.2204 50.5304 15.2756 50.5304C16.3309 50.5304 17.3429 50.1112 18.0891 49.365C18.8353 48.6188 19.2545 47.6068 19.2545 46.5515V46.5515Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_1116_1028">
          <rect
            width="63.6615"
            height="63.6615"
            fill="white"
            transform="translate(0.686554 0.130859)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TruckIcon;
